// eslint-disable-next-line no-unused-vars
import qs from 'querystring';

const namespaced = true;

const state = {
  items: []
};

const getters = {
  items: state => state.items
};

const mutations = {
  SET_ITEM: (state, payload) => (state.items = payload)
};

const actions = {
  // eslint-disable-next-line no-unused-vars
  async fetchList({ commit }, { classId, courseId }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/assignment/student/class/${classId}/course/${courseId}/score`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchListParent({ commit }, { studentId, classId, courseId }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/assignment/parent/student/${studentId}/class/${classId}/course/${courseId}/score`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // // eslint-disable-next-line no-unused-vars
  // fetchList: ({ commit }) => {
  //   const fakeData = [
  //     {
  //       id: 1,
  //       name: 'Quiz 4 Chapter IX “Virus”',
  //       due: 'Apr 4 by 9:43 AM',
  //       score: 9,
  //       outOf: 9,
  //       mean: 9,
  //       high: 9,
  //       low: 0,
  //       totalGroup: '100%',
  //       group: [
  //         {
  //           nameGroup: 'Home Work',
  //           weightGroup: '60%'
  //         },
  //         {
  //           nameGroup: 'Exam',
  //           weightGroup: '60%'
  //         }
  //       ]
  //     },
  //     {
  //       id: 2,
  //       name: 'Resume Chapter IX “Virus”',
  //       due: 'Apr 2 by 10:23 AM',
  //       score: 9,
  //       outOf: 9,
  //       mean: 9,
  //       high: 9,
  //       low: 0,
  //       totalGroup: '100%',
  //       group: [
  //         {
  //           nameGroup: 'Home Work',
  //           weightGroup: '60%'
  //         },
  //         {
  //           nameGroup: 'Exam',
  //           weightGroup: '60%'
  //         }
  //       ]
  //     }
  //   ];
  //   return fakeData;
  //   // commit('SET_ITEM', fakeData);
  //   // return Promise.resolve();
  // },
  // eslint-disable-next-line no-unused-vars
  fetchListData: ({ commit }) => {
    const fakeDatas = {
      assignmentGroups: [
        {
          groupId: 27,
          groupName: 'Mantap'
        },
        {
          groupId: 65,
          groupName: 'mancing mania'
        }
      ],
      assignments: [
        {
          assignmentId: 33,
          groupId: 27,
          groupName: 'Mantap',
          assignmentTitle: 'we got histoy',
          dueDate: '30-10-2020 14:08',
          score: 0.0,
          totalScore: 100
        },
        {
          assignmentId: 31,
          groupId: 27,
          groupName: 'Mantap',
          assignmentTitle: 'unlock manuala',
          dueDate: '30-10-2020 15:15',
          score: 0.0,
          totalScore: 100
        },
        {
          assignmentId: 50,
          groupId: 27,
          groupName: 'Mantap',
          assignmentTitle: 'Unlimated Upload',
          dueDate: '30-10-2020 13:04',
          score: 0.0,
          totalScore: 100
        },
        {
          assignmentId: 14,
          groupId: 27,
          groupName: 'Mantap',
          assignmentTitle: 'Attendance',
          dueDate: '16-10-2020 03:14',
          score: 100.0,
          totalScore: 100
        },
        {
          assignmentId: 56,
          groupId: 65,
          groupName: 'mancing mania',
          assignmentTitle: 'sadsa',
          dueDate: '31-10-2020 14:10',
          score: 0.0,
          totalScore: 100
        }
      ],
      groups: [
        {
          assignmentGroupId: 27,
          assignmentGroupName: 'Mantap',
          groupWeight: 80.0
        },
        {
          assignmentGroupId: 65,
          assignmentGroupName: 'mancing mania',
          groupWeight: 80.0
        }
      ]
    };
    return fakeDatas;
    // commit('SET_ITEM', fakeData);
    // return Promise.resolve();
  },

  // eslint-disable-next-line no-unused-vars
  exportStudent({ commit }, { classId, courseId }) {
    return window.axios.get(`/api/assignment/student/class/${classId}/course/${courseId}/export`, { responseType: 'arraybuffer' });
  },
  // eslint-disable-next-line no-unused-vars
  exportParent({ commit }, { studentId, classId, courseId }) {
    return window.axios.get(`/api/assignment/parent/student/${studentId}/class/${classId}/course/${courseId}/export`, {
      responseType: 'arraybuffer'
    });
  }

  // fetchList: ({ commit, rootGetters }, { course, arrangeBy }) => {
  //   const defaultPageable = rootGetters['table/defaultPageable'];
  //   const queryParams = {
  //     limit: defaultPageable.limit,
  //     page: defaultPageable.currentPage - 1,
  //     search: defaultPageable.search,
  //     course,
  //     arrangeBy
  //   };

  //   return window.axios
  //     .get('', {
  //       params: queryParams,
  //       paramsSerializer: function(params) {
  //         return qs.stringify(params);
  //       }
  //     })
  //     .then(response => {
  //       let data = response.data.data;
  //       commit('SET_ITEM', data.content);
  //       commit('table/SET_DEFAULT_TOTAL_PAGES', data.totalPages, { root: true });
  //       commit('table/SET_DEFAULT_TOTAL_ELEMENTS', data.totalElements, { root: true });
  //       return data;
  //     })
  //     .catch(error => {
  //       throw error;
  //     });
  // }
};

export default { namespaced, state, getters, mutations, actions };
